module.exports = __webpack_public_path__ + "9b79d842fa57b564b410523960b698d8.svg";